import { call, put, takeLatest, delay } from "redux-saga/effects";
import {
  vendorPendingActionRequests,
  vendorRetreievedPendingActions,
  loadingActionRequests,
} from "../actions/index.js";
import { vendorPendingActionsService } from "../services/index.js";

export function* vendorActionsRequest() {
  yield delay(1000);
  const response = yield call(vendorPendingActionsService);
  const data = yield response.data;
  yield put(vendorRetreievedPendingActions(data));
  yield put(loadingActionRequests(false));
}

export function* vendorPendingActionsSaga() {
  yield takeLatest(
    vendorPendingActionRequests.toString(),
    vendorActionsRequest
  );
}
